import { Text, Icon, TwButton as Button } from "@ui-component-library";
import { DynamicModal } from "@components/DynamicModal";

import type { KYCDoneProps } from './KYC.types';

export const KYCDone = ({ isSubmitting, hasError, onRetry, onSkip }: KYCDoneProps) => {
  if (hasError) {
    return (
      <DynamicModal isOpen={true} onClose={() => { }} bp={{ sm: "drawer", lg: "dialog" }} dialogSize="medium"
      >
        <DynamicModal.Header>
          <>
            <Icon name="WarningCircle" size="xlarge" className="fill-[#CC9000] bg-[#A065001A] rounded-full p-3" />
            <Button size="icon" variant="tertiary" onClick={onSkip}>
              <Icon name="CrossSimple" />
            </Button>
          </>
        </DynamicModal.Header>
        <DynamicModal.Content>
          <div className="flex gap-3 flex-col items-start self-stretch md:h-full md:justify-center">
            <Text variant="text-lg/leading-normal/medium">Något gick fel</Text>
            <Text variant="text-sm/leading-normal/normal">
              Vi letar efter stigen tillbaka och löser problemet så snabbt vi kan – tack för ditt tålamod.
            </Text>
            <div className="bg-gray-100 rounded-lg p-4 w-full">
              <Text variant="text-xs/leading-normal/normal" className="font-medium text-charcoal-900 mb-1 block">
                Behöver du hjälp?
              </Text>
              <Text variant="text-xs/leading-normal/normal" className="text-charcoal-600 mb-1 block leading-tight">
                Försök gärna igen om en stund. Om felet kvarstår, kontakta supporten.
              </Text>
              <Text variant="text-xs/leading-normal/normal" className="text-charcoal-900">
                information@treebula.se
              </Text>
            </div>
          </div>

        </DynamicModal.Content>
        <DynamicModal.Footer>

          <>
            <Button variant="tertiary" className="w-full" onClick={onSkip}>Hoppa över</Button>
            <Button className="w-full" onClick={onRetry} disabled={isSubmitting}>
              {isSubmitting ? 'Skickar...' : 'Försök igen'}
            </Button>
          </>
        </DynamicModal.Footer>
      </DynamicModal>
    )
  }
  return (
    <div className="flex min-h-[300px] w-full flex-col items-center justify-center text-center">
      <div className="mb-8 flex h-28 w-28 items-center justify-center rounded-2xl bg-white shadow-sm">
        {isSubmitting ? (
          <div className="h-12 w-12 animate-spin rounded-full border-4 border-[#E6E6E6] border-t-green-spruce-700" />
        ) : (
          <Icon name="CheckSimple" size="xxlarge" className="fill-green-spruce-700" />
        )}
      </div>
      <Text variant="text-xl/leading-normal/medium" className="mb-3">
        Klar!
      </Text>
      <Text variant="text-sm/leading-normal/normal" className="text-[#737373]">
        Tack för dina svar. Vi har nu anpassat din upplevelse.
      </Text>
    </div>
  );
};